import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { rankingList, rankingListProps, rankingBeList } from './config';

export interface HomeRankingsState {
  list: rankingListProps[];
  beList: rankingListProps[];
  isWorldLegend: boolean;
  navTabbtnId1: number;
  navTabbtnId2: number;
  navTabbtnId4: number;
}

const HOMERANKING_KEY = 'React-ts-ant-homeRanking';

const localHomeRankings = LocalStore.getValue<HomeRankingsState>(HOMERANKING_KEY) || {};

export const defaults: HomeRankingsState = {
  list: rankingList,
  beList: rankingBeList,
  isWorldLegend: false,
  navTabbtnId1: 1,
  navTabbtnId2: 1,
  navTabbtnId4: 1,
  ...localHomeRankings
};

const HOME_RANKING_KEY = 'React-ts-ant-HOMERANKINGS';

export const updateHomeRankings: (homeRankings: HomeRankingsState) => IAction<HomeRankingsState> = (
  homeRankings: HomeRankingsState
) => ({
  type: HOME_RANKING_KEY,
  payload: homeRankings
});

const homeRankingReducer: Reducer<HomeRankingsState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case HOME_RANKING_KEY:
      LocalStore.setValue(HOMERANKING_KEY, payload as HomeRankingsState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default homeRankingReducer;
